(() => {
  if (!/^en(?:-|$)/i.test(document.documentElement.lang)) return;
  const copy = document.body.getAttribute('data-flexicare-cookie-copy');
  if (!copy) return;
  const updateCopy = () => {
    const paragraph = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    if (!paragraph || !paragraph.querySelector('#shopify-pc__banner__body-policy-link')) return false;
    const text = Array.from(paragraph.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
    if (text) text.textContent = copy;
    return true;
  };
  if (updateCopy()) return;
  const observer = new MutationObserver(() => {
    if (updateCopy()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 30000);
})();
